const MAX_LINES = 120;
const MAX_EXPORT_CHARS = 7000;
/** Префиксы console.log, которые тоже кладём в буфер (не только warn/error). */
const CAPTURE_PREFIXES = [
  "[bezpart-board]",
  "[WbBoardScene]",
  "[bug-report]",
  "ops",
  "revision_conflict",
];

type LogLevel = "log" | "warn" | "error";

const buffer: string[] = [];
let installed = false;

function formatArg(value: unknown): string {
  if (value instanceof Error) {
    return `${value.name}: ${value.message}`;
  }
  if (typeof value === "string") return value;
  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
}

function shouldCaptureLog(args: unknown[]): boolean {
  const first = args[0];
  if (typeof first === "string") {
    return CAPTURE_PREFIXES.some((p) => first.includes(p));
  }
  return false;
}

function pushLine(level: LogLevel, args: unknown[]) {
  const ts = new Date().toISOString().slice(11, 23);
  const text = args.map(formatArg).join(" ");
  buffer.push(`${ts} ${level} ${text}`);
  while (buffer.length > MAX_LINES) buffer.shift();
}

/** Кольцевой буфер console warn/error + важные log — для баг-репорта (как в звонилке). */
export function installClientLogBuffer() {
  if (installed || typeof window === "undefined") return;
  installed = true;

  (["log", "warn", "error"] as const).forEach((level) => {
    const original = console[level].bind(console);
    console[level] = (...args: unknown[]) => {
      if (level === "error" || level === "warn" || shouldCaptureLog(args)) {
        pushLine(level, args);
      }
      original(...args);
    };
  });

  window.addEventListener("unhandledrejection", (event) => {
    pushLine("error", ["[unhandledrejection]", event.reason]);
  });
  window.addEventListener("error", (event) => {
    pushLine("error", ["[window.error]", event.message, event.filename, event.lineno]);
  });
}

export function getClientLogExport(): string {
  const text = buffer.join("\n");
  if (!text) return "—";
  if (text.length <= MAX_EXPORT_CHARS) return text;
  return `…(обрезано)\n${text.slice(-MAX_EXPORT_CHARS)}`;
}

export function noteClientLog(tag: string, detail?: string) {
  pushLine("log", [tag, detail ?? ""].filter(Boolean));
}
